import { PText, PFlex, PContentWrapper } from '@porsche-design-system/components-react'
import React from 'react'

import styles from './rail.module.css'

type Props = {
  percentage?: any
  bgColor?: string
  totalStarsRatings?: number
}

const Rail: React.FC<Props> = ({ percentage, bgColor, totalStarsRatings }) => {
  return (
    <PContentWrapper width='extended' className={styles.wrapper}>
      <span className={styles.rail}>
        <span
          className={styles.railPercentage}
          style={{
            width: `${percentage === 0 || percentage === undefined || percentage === '-' ? 0 : percentage}%`,
            background: `${bgColor}`
          }}
        />
      </span>
      <PFlex direction='row' justifyContent='space-between' className={styles.textRating}>
        <PText>{percentage === 0 || percentage === undefined ? '-' : percentage} %</PText>
        <PText>{totalStarsRatings === 0 || totalStarsRatings === undefined ? 0 : totalStarsRatings} Bewertungen</PText>
      </PFlex>
    </PContentWrapper>
  )
}

export default Rail
